<template>
	<div class="page-dashboard">
		<!-- <div class="app-loader is-loading dark large mt-4"></div> -->
		<div class="modals">
			<!-- Greetings -->
			<modal
				class="greetings-modal"
				size="small-medium"
				@close="isGreetingsVisible = false"
				v-if="user && isGreetingsVisible">
				<template slot="header">
					<h5 class="mb-0">{{ $t('Greetings') }}</h5>
				</template>
				<template slot="body" class="text-left">
					<h2 class="text-white mb-3">Hello {{ name }}</h2>
					<p class="mb-5">{{ $t('Welcome to Grafias, Let\'s begin shall we?') }}</p>
					<p class="mb-2">{{ $t('For quick start you can watch our') }} <a class="text-underline" href="/tutorials" target="_blank">{{ $t('tutorial playlist here') }}</a></p>
					<p class="mb-4">{{ $t('If you prefer to read, here are the links for') }} <a href="/docs" target="_blank" class="text-underline">{{ $t('documentation') }}</a></p>
					<p class="mb-5">{{ $t('Would you like some demo content activated for you to get started') }}?<br>{{ $t('if so') }} <router-link class="text-underline" to="/demo-content">{{ $t('Click Here') }}</router-link></p>
					<p class="mb-0">{{ $t('Finally if you have some question, please don\'t hesitate to contact us') }},<br>{{ $t('once again thank you for joining Grafias') }}</p>
				</template>
				<div slot="footer"></div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
	name: 'dashboard',
	components: {
		Modal,
	},
	data() {
		return {
			isGreetingsVisible: false,
		};
	},
	methods: {
		...mapActions({
			isLoggedIn: 'isLoggedIn',
			fetchUser: 'fetchUser',
		}),
		checkGreetings() {
			const key = 'last_logged_in';
			const lastLoggedIn = localStorage.getItem(key);
			if (!lastLoggedIn || lastLoggedIn === '') {
				this.isGreetingsVisible = true;
				localStorage.setItem(key, new Date());
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			role: 'role',
			isFetchingUser: 'isFetchingUser',
		}),
		name() {
			return this.user ? this.user.name : '-';
		},
	},
	created() {
		this.checkGreetings();
		// Fetch user if logged in
		if (this.isLoggedIn && !this.user && !this.isFetchingUser) {
			this.fetchUser();
		}
	},
};
</script>
